const mutations = {
  ORDERS (state, data) {
    state.orders = data
  },
  CURRENT_ORDER (state, data) {
    state.currentOrder = data
  },
  CURRENT_ORDER_PAYMENT(state, data) {
    state.currentOrderPayment = data
  },
  PUSHORDERS (state, data) {
    state.orders.push(data)
  },
  EVALUATE_ORDER (state, data) {
    state.evaluateOrder = data
  },
  ID_ACTION_CABLE (state, data) {
    state.idActionCable = data
  },
  ACTIVE_ORDER (state, data) {
    state.activeOrder = data
  },
  LOGS (state, data) {
    state.currentOrder['logs'] = data
  },
  RATED (state, data) {
    state.currentOrder.is_rated = data
  },
  ORDERS_META (state, data) {
    state.ordersMeta = data
  },
  OPEN_CASHBACK_MODAL (state, data) {
    state.openCashbackModal = data;
  }
}

export default mutations
